module.exports = __webpack_public_path__ + "img/kehou.072cc523.jpg";